import { ProjectSearchInput } from "@/components/projects/ProjectSearchInput";
import { ProjectsList } from "@/components/projects/ProjectsList";
import { type FC, useState } from "react";
import { useDebounce } from "use-debounce";

export const ProjectTab: FC<{
    onClose: () => void;
}> = ({ onClose }) => {
    const [projectSearch, setProjectSearch] = useState("");
    const [debouncedProjectSearch] = useDebounce(projectSearch, 100, {});

    return (
        <form className="flex max-h-[500px] flex-col gap-4">
            <div className="mt-8 flex items-center gap-2 focus-visible:ring-2">
                <ProjectSearchInput searchValue={projectSearch} setSearchValue={setProjectSearch} />
            </div>
            <div className="grow overflow-y-auto p-2">
                <ProjectsList
                    onCreateSuccess={onClose}
                    search={debouncedProjectSearch}
                    canEdit={false}
                    disableActions
                />
            </div>
        </form>
    );
};
